import { Link } from "react-router-dom";
import {
  DoorOpen, ClipboardList, Pill, FileText, Apple, Activity, Accessibility,
  AlertTriangle, ShieldAlert, Phone, CheckCheck, NotebookPen
} from "lucide-react";
import { PageHero, DisclaimerBar } from "../components/shared/Primitives";

const TOOLS = [
  { icon: DoorOpen, title: "Arrival Check", body: "Home + client condition on arrival. Protects both sides.", cta: "Open form" },
  { icon: ClipboardList, title: "Daily Care Log", body: "Simple daily record of care delivered and how the day went.", cta: "Open log" },
  { icon: Pill, title: "Medication Record", body: "MAR-style record for prompted or administered medication.", cta: "Open record" },
  { icon: NotebookPen, title: "Handover Notes", body: "Pass on the right information to the next carer, every time.", cta: "Open notes" },
  { icon: Apple, title: "Food & Fluid Chart", body: "Track intake cleanly when it matters.", cta: "Open chart" },
  { icon: Activity, title: "Mood / Behaviour Notes", body: "Short daily notes on mood, engagement and anything notable.", cta: "Open notes" },
  { icon: Accessibility, title: "Mobility & Transfers", body: "Record transfers, falls-risk observations and equipment used.", cta: "Open record" },
  { icon: AlertTriangle, title: "Incident Report", body: "Structured record of falls, near-misses or anything to escalate.", cta: "Open report" },
  { icon: ShieldAlert, title: "Safeguarding Concern", body: "Raise a concern through the right structured form, with guidance.", cta: "Open form" },
  { icon: Phone, title: "Emergency / Escalation", body: "Who to call, what to say, what to write down afterwards.", cta: "Open guide" },
  { icon: CheckCheck, title: "End-of-Shift Summary", body: "Close the shift with a clear summary — handover-ready.", cta: "Open summary" },
  { icon: FileText, title: "Visit Signature", body: "Simple digital signature capture with date & time.", cta: "Open sign" },
];

export default function ShiftToolkit() {
  return (
    <div data-testid="page-shift-toolkit">
      <PageHero
        eyebrow="Shift Toolkit"
        title="The on-shift essentials — in one place."
        description="Everything you need to document a shift to professional standard. Quick to open, simple to complete."
        accent="purple"
        bgTint="carer"
      />
      <section className="section">
        <div className="container-jcc">
          <div className="mb-8"><DisclaimerBar /></div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {TOOLS.map((t) => (
              <div key={t.title} className="card-base p-6 flex flex-col" data-testid={`tool-${t.title.toLowerCase().replace(/[^a-z]+/g, '-')}`}>
                <div className="w-11 h-11 rounded-xl bg-purple-50 text-purple flex items-center justify-center mb-4">
                  <t.icon className="w-5 h-5" strokeWidth={1.75} />
                </div>
                <h3 className="font-display text-lg font-semibold">{t.title}</h3>
                <p className="mt-2 text-ink-muted text-sm flex-1">{t.body}</p>
                <button className="btn-outline mt-5">{t.cta}</button>
              </div>
            ))}
          </div>
          <div className="mt-12 rounded-3xl bg-surface-carer p-8 text-center">
            <p className="text-ink-muted">Interactive versions of each form are part of <strong>Pro Carer Office</strong>. Templates of all of these are included at joining.</p>
            <Link to="/pro-carer-circle" className="btn-purple mt-5 inline-flex">Unlock the full toolkit</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
